import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PropertyService } from '@app/_components/property/property.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConstantService } from '@app/_services/constant.service';
import { AlertService } from '@app/_services/alert.service';
import { ReservationService } from '../../reservation.service';
import { AuthenticationService } from '@app/_services/authentication.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Calendar } from 'primeng/calendar';

@Component({
    selector: 'app-reservation-create',
    templateUrl: './reservation-create.component.html',
    styleUrls: ['./reservation-create.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ReservationCreateComponent implements OnInit {

	@ViewChild('checkInDateCal') public checkInDateCalender: Calendar;
	@ViewChild('checkOutDateCal') public checkOutDateCalender: Calendar;

	@Output() doUpdate = new EventEmitter<any>();

	//For reservation list to be shown on dialog
	formTitle: String;
	reservation: any;
	showCreateReservationPopUp = false;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;

	updatedCheckInDate: Date;
	checkOutDateBasedOnCheckinDate: Date;
	isDateLessThanCheckinDate = false;
	isDisplayClearDates = false;
	minDate: Date;
	maxDate: Date;

	validationMessages = {
		orderId: [],
		shortTermRentalId: [{ type: 'required', message: 'Required' }],
		ownerProfileId: [],
		emailAddress: [{ type: 'required', message: 'Required' },
		{ type: 'email', message: 'Not a valid Email' }],
		referralSourceId: [{ type: 'required', message: 'Required' }],
		numAdults: [{ type: 'required', message: 'Required' }],
		numChildren: [{ type: 'required', message: 'Required' }],
		checkOutDate: [{ type: 'required', message: 'Required' }],
		checkInDate: [{ type: 'required', message: 'Required' }],
		firstName: [{ type: 'required', message: 'Required' }],
		lastName: [{ type: 'required', message: 'Required' }],
		reservationType: [{ type: 'required', message: 'Required' }],
	};
	referralSources: any[];
	properties: any[] = [];
	owners: any[] = [];
	numAdults: any[];
	readOnlySubmitBotton = false;
	openNewTab: any;
	childrens: any[];
	reservationTypes: any[];

	constructor(
		public authenticationService: AuthenticationService,
		public reservationService: ReservationService,
		public alertService: AlertService,
		public constantService: ConstantService,
		private messageService: MessageService,
		private formBuilder: UntypedFormBuilder,
		private confirmationService: ConfirmationService,
		public router: Router,
		private propertyService: PropertyService,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
		this.formTitle = "Create Reservation",
			this.reservation = data.reservation;
		this.openNewTab = data.openNewTab;
		this.referralSources = this.reservationService.referralSources;
		this.numAdults = this.reservationService.numAdults;
		this.childrens = this.reservationService.children;
		this.reservationTypes = this.reservationService.reservationTypes;
	}

	ngOnInit(): void {
		let today = new Date();
		let month = today.getMonth();
		let year = today.getFullYear();
		let day = today.getDate();
		this.updatedCheckInDate = today;
		this.minDate = new Date();
		this.maxDate = new Date(year + 3, month, day);
		this.formBuild();
		this.fetchProperties();
	}

	fetchProperties() {
		try {
			this.propertyService.propertySummaryForShortData()
				.subscribe(
					res => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.properties = res.data.properties;
						this.form1.patchValue(this.reservation);
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	onOwnerChange(event) {
		this.owners.forEach(owner => {
			if(owner.ownerProfileId == event.value)
			{
				this.form1.patchValue({
					guestProfile: {
						firstName: owner?.firstName,
						lastName: owner?.lastName,
						emailAddress: owner?.emailAddress,
						mobilePhone: owner?.mobilePhone
					}
				  });
				return;
			}
		});
	}

	fetchOwners(event) {
		try {
			if(this.form1.value.shortTermRentalId && this.form1.value.reservationType
				&& (this.form1.value.reservationType == 1 || this.form1.value.reservationType == 2))
			{
				this.owners = [];
				this.form1.patchValue({
					ownerProfileId: null,
					guestProfile: {
						firstName: null,
						lastName: null,
						emailAddress: null,
						mobilePhone: null
					}
				  });
				this.propertyService.ownerListByProperty(this.form1.value.shortTermRentalId)
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.owners = res.data.ownerProfiles;
							this.owners.forEach(owner => {
								owner.combinedLabel = `${owner.emailAddress} | ${owner.mobilePhone}`;
							  });
							  if(this.owners && this.owners.length == 1)
							  this.form1.patchValue({
								ownerProfileId: this.owners[0].ownerProfileId,
								guestProfile: {
									firstName: this.owners[0]?.firstName,
									lastName: this.owners[0]?.lastName,
									emailAddress: this.owners[0]?.emailAddress,
									mobilePhone: this.owners[0]?.mobilePhone
								}
							  });
							this.form1.patchValue(this.reservation);
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			}
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			orderId: [this.reservation?.orderId],
			shortTermRentalId: ['', Validators.required],
			ownerProfileId: [],
			reservationType: [3, Validators.required],
			referralSourceId: [11, Validators.required],
			numAdults: [2, Validators.required],
			numChildren: [0],
			checkOutDate: ['', Validators.required],
			checkInDate: ['', Validators.required],
			paymentPreferenceDeposit: ['NC'],
			guestProfile: this.formBuilder.group({
				firstName: ['', Validators.required],
				lastName: ['', Validators.required],
				emailAddress: ['', Validators.compose([Validators.required, Validators.email])],
				mobilePhone: [],
				guestCompanions: new UntypedFormArray([]),
			}),
		});
	}

	// Create reservation method
	createReservation() {
		// Guard: prevent duplicate POSTs when the server is slow or returns 504.
		// readOnlySubmitBotton disables the button, but 504 error handler resets it — so
		// also check formLoading here to block a second click after a 504 re-enables the button.
		if (this.formLoading || this.readOnlySubmitBotton) { return; }
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}

			let reservationRequest = this.form1.value;

			const formData = JSON.parse(JSON.stringify(this.form1.value));
			if (formData.checkInDate != "undefined" && formData.checkInDate != null) {
				if (formData.checkInDate.includes("T")) {
					formData.checkInDate = moment(formData.checkInDate).format("YYYY-MM-DD");
				} else {
					var splitDateOfCheckInDate = formData.checkInDate.split('/');
					if (splitDateOfCheckInDate[0].length == 2) {
						var monthOfCheckInDate = splitDateOfCheckInDate[0];
						var dayOfCheckInDate = splitDateOfCheckInDate[1];
						var yearOfCheckInDate = splitDateOfCheckInDate[2];
						formData.checkInDate = yearOfCheckInDate + "-" + monthOfCheckInDate + "-" + dayOfCheckInDate;
					}
					if (splitDateOfCheckInDate[0].length == 4) {
						var yearOfCheckInDate = splitDateOfCheckInDate[0];
						var monthOfCheckInDate = splitDateOfCheckInDate[1];
						var dayOfCheckInDate = splitDateOfCheckInDate[2];
						formData.checkInDate = yearOfCheckInDate + "-" + monthOfCheckInDate + "-" + dayOfCheckInDate;
					}
				}
			} else {
				formData.checkInDate = '';
			}
			if (formData.checkOutDate != "undefined" && formData.checkOutDate != null) {
				if (formData.checkOutDate.includes("T")) {
					formData.checkOutDate = moment(formData.checkOutDate).format("YYYY-MM-DD");
				} else {
					var splitDateOfCheckOutDate = formData.checkOutDate.split('/');
					if (splitDateOfCheckOutDate[0].length == 2) {
						var monthOfCheckOutDate = splitDateOfCheckOutDate[0];
						var dayOfCheckOutDate = splitDateOfCheckOutDate[1];
						var yearOfCheckOutDate = splitDateOfCheckOutDate[2];
						formData.checkOutDate = yearOfCheckOutDate + "-" + monthOfCheckOutDate + "-" + dayOfCheckOutDate;
					}
					if (splitDateOfCheckOutDate[0].length == 4) {
						var yearOfCheckOutDate = splitDateOfCheckOutDate[0];
						var monthOfCheckOutDate = splitDateOfCheckOutDate[1];
						var dayOfCheckOutDate = splitDateOfCheckOutDate[2];
						formData.checkOutDate = yearOfCheckOutDate + "-" + monthOfCheckOutDate + "-" + dayOfCheckOutDate;
					}
				}
			} else {
				formData.checkOutDate = '';
			}
			// this.form1.patchValue({
			//   checkInDate: formData.checkInDate,
			//   checkOutDate: formData.checkOutDate
			// });
			reservationRequest.checkInDate = formData.checkInDate;
			reservationRequest.checkOutDate = formData.checkOutDate;
			let reservationType = this.reservationTypes.find(e => e.value == formData.reservationType);
			reservationRequest.channelName = reservationType?.channel
			reservationRequest.reservationStatus = reservationType?.reservationStatus
			reservationRequest.bookingAgent = {
				"setCommissionAmount": null,
				"setCommissionPaidBy": "BOOKING_COMMISSION_PAID_BY_GUEST",
				"channelId": 12
			};

			reservationRequest.contract = {
				"signName": "KBM Resorts null",
				"signEmail": "dev@kbmresorts.cpm"
			};
			reservationRequest.invoice = {
				"invoiceDetails": [],
			};
			reservationRequest.paymentSource = {};
			this.readOnlySubmitBotton = true;
			this.formLoading = true;
			this.reservationService.createReservation(reservationRequest)
				.subscribe(
					(res: any) => {
						this.formLoading = false;
						// this.showCreateReservationPopUp = false;
						if (res.data?.reservationSummary?.reservationApiList[0]?.status == "INVALID") {
							this.confirmationService.confirm({
								header: 'Create Reservation Error',
								message: res.data?.reservationSummary?.reservationApiList[0]?.errors[0]?.message,
								icon: 'fa fa-exclamation-triangle',
								rejectVisible: false,
								acceptLabel: 'Close',
								accept: () => {
									//Actual logic to perform a confirmation
									this.formLoading = false;
								}
							});
						} else {
							this.messageService.add({ severity: 'success', summary: 'Success', detail: "Create Reservation Successfully" });
							if (this.openNewTab == true) {
								this.router.navigate([]).then(result => { window.open('/order/' + res.data?.reservationSummary?.reservationApiList[0]?.orderId, '_blank'); });
							} else {
								this.router.navigate(['/order/' + res.data?.reservationSummary?.reservationApiList[0]?.orderId])
							}
							this.doUpdate.emit();
						}
						console.log('reservation-add SUCCESS: ' + JSON.stringify(res));
					},
					(err: any) => {
						// Do NOT reset formLoading or readOnlySubmitBotton on error.
						// A 504 gateway timeout means Apache timed out but the backend may have
						// already created the reservation. Resetting the guard here re-enables
						// the submit button and lets the user create a duplicate reservation.
						// The error interceptor surfaces a "check before resubmitting" warning.
						// readOnlySubmitBotton and formLoading stay true until the user reloads.
						const errorMsg = (typeof err === 'string') ? err : (err?.error?.message || err?.message || 'An error occurred.');
						this.confirmationService.confirm({
							header: 'Reservation Error',
							message: errorMsg,
							icon: 'fa fa-exclamation-triangle',
							rejectVisible: false,
							acceptLabel: 'Close',
							accept: () => {
								//Actual logic to perform a confirmation
							}
						});
						console.log('reservation-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });

		} catch (error) {
			this.readOnlySubmitBotton = false;
			this.formLoading = false;
			this.alertService.error(error);
		}
	}

	// if select checkin date at that time checkout date set as null
	onKeyDate(event: any) {
		event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
		// this.form1.patchValue({
		// 	checkOutDate: ""
		// });
	}

	// if select checkout date at that time check checkin date must be below lessthan one day of selected date
	onKeyDateForCheckOutDate(event: any) {
		event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
		if (this.form1.value.checkInDate) {
			let today = new Date(this.form1.value.checkInDate);
			this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
			this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
		}
	}

	// compare checkin and checkout dates
	compareDate(date: any) {
		this.isDateLessThanCheckinDate = false;
		if (Date.parse(date.target.value) < Date.parse(moment(this.checkOutDateBasedOnCheckinDate).format("MM/DD/YYYY"))) {
			this.isDateLessThanCheckinDate = true;
		}
	}

	// open guest modal
	openGuestModal(e: any) {
		// this.dropdown.show();
	}

	// change checking date
	checkInChange(e: any) {
		let today = new Date(e.valueOf());
		this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
		this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
		this.isDisplayClearDates = true;
		if(this.form1.value.checkOutDate && this.form1.value.checkInDate 
			&& this.form1.value.checkOutDate < this.form1.value.checkInDate)
			{
				this.form1.patchValue({
					checkOutDate: ""
				});
			}
		window.setTimeout(() => {
			this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
		}, 1);
	}

	// change checkout date
	checkOutChange(e: any) {
		this.isDisplayClearDates = true;
		// this.guestDropdownCount.show();
	}

}
